import gql from 'graphql-tag';

const VERIFY_LOCK_TOKEN_TRX = gql`
    mutation verifyLockTokenTransaction(
        $lockTokenId: String!
        $trxHash: String!
        $walletAddress: String!
    ) {
        verifyLockTokenTransaction(
            verifyTrxInput: {
                lockTokenId: $lockTokenId
                trxHash: $trxHash
                walletAddress: $walletAddress
            }
        )
            {
                id
                walletAddress
                duration
                tickets
                totalToken
                lockTrxHash
                unlockTrxHash
                isVerified
                lockedAt
                expiresAt
                status
                userId
            }
    }
`

export default VERIFY_LOCK_TOKEN_TRX;